import { render, staticRenderFns } from "./TweetPreview.vue?vue&type=template&id=0220ffbc&"
import script from "./TweetPreview.vue?vue&type=script&lang=js&"
export * from "./TweetPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports